import {
  applyMiddleware,
  compose,
  createStore,
  Reducer,
  Middleware,
  Store,
  StoreEnhancer,
  DeepPartial,
} from 'redux';

export function setupStore<T>(
  rootReducer: Reducer<T>,
  initialState: DeepPartial<T>,
  middleware: Middleware[] = [],
  enhancers: StoreEnhancer[] = []
): Store<T> {
  return createStore(
    rootReducer,
    initialState,
    compose(
      applyMiddleware(...middleware),
      ...enhancers
    )
  ) as Store<T>;
}
